import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { canAddToCart } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductAddToListLink, { ProductAddToListLinkStyles } from "@ucs/Overrides/Components/ProductAddToListLink";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => ({
    productSettings: getSettingsCollection(state).productSettings,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    isAuthenticated: state.context.session!.isAuthenticated,
    userRoles: state.context.session!.userRoles,
    canAddToCart: canAddToCart(
        state,
        props.productContext.product,
        props.productContext.productInfo,
        state.pages.productDetails.configurationCompleted,
        state.pages.productDetails.variantSelectionCompleted,
    ),
});

export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductAddToListLinkStyles;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    wrapper: {
        css: css`
            margin-top: 30px;
            text-align: center;
        `,
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink: React.FC<OwnProps> = ({
    product,
    variantSelectionCompleted,
    isAuthenticated,
    userRoles,
    productContext,
    productSettings,
    canAddToCart,
}) => {
    // if (!product.canAddToWishlist && !variantSelectionCompleted) {
    //     return null;
    // }

    return isAuthenticated &&
        (userRoles.toLowerCase().includes("buyer") ||
            userRoles.toLowerCase().includes("vip") ||
            userRoles.toLowerCase().includes("administrator") ||
            userRoles.toLowerCase().includes("architects & designers") ||
            userRoles.toLowerCase().includes("accountinguser_billtrustonly")) ? (
        <StyledWrapper {...styles.wrapper}>
            <ProductAddToListLink
                disabled={!productSettings.canAddToCart || !canAddToCart}
                data-test-selector="productDetails_addToList"
                extendedStyles={styles.link}
            />
        </StyledWrapper>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(withProduct(ProductDetailsAddToListLink))),
    definition: {
        displayName: "Add to List Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
